function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.748 2.7h-13.5C1.292 2.7.477 3.486.477 4.47v9.113c0 .956.787 1.771 1.771 1.771h13.5c.957 0 1.772-.787 1.772-1.771V4.443c0-.956-.815-1.744-1.772-1.744zm0 1.265h.085L8.998 8.352 2.164 3.965h13.584zm0 10.069h-13.5a.504.504 0 01-.506-.507V5.202l6.581 4.22c.197.14.422.196.647.196.225 0 .45-.056.647-.197l6.581-4.219v8.354c.057.28-.168.478-.45.478z",
  fill: "#DEE4EE"
}));